import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-66c928aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-intro" }
const _hoisted_2 = { class: "desc" }
const _hoisted_3 = {
  class: "cm-ui-mt20",
  "label-width": "0"
}
const _hoisted_4 = { class: "check-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_CmSvgIcon, {
        name: "assets/icons/info-1",
        class: "cm-ui-mr5 cm-ui-ml5",
        monochrome: "",
        "aria-hidden": false,
        size: 16,
        "aria-label": "tip"
      }),
      _createTextVNode(" " + _toDisplayString(_ctx.t('teamPage.createTeamIntro')), 1)
    ]),
    (_openBlock(), _createBlock(_component_el_form, {
      model: _ctx.createTeamForm,
      rules: _ctx.rules,
      ref: "createTeamFormRef",
      "label-width": "100px",
      class: "form",
      "label-position": "top",
      key: _ctx.locale
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          prop: "name",
          label: _ctx.t('teamManage.teamName')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              class: "create-input",
              size: "medium",
              modelValue: _ctx.createTeamForm.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.createTeamForm.name) = $event)),
              placeholder: _ctx.t('teamPage.createTeamNamePlaceholder'),
              maxlength: _ctx.NAME_MAX_LENGTH
            }, null, 8, ["modelValue", "placeholder", "maxlength"]),
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.t('teamPage.createTeamNameDesc')), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.userCheck,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userCheck) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('teamPage.createTeamAgreeBefore')), 1),
                _createVNode(_component_el_link, {
                  class: "privacy",
                  style: {"line-height":"1"},
                  href: "/privacy/dubateamLicenseandserviceterms.html",
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('teamPage.createTeamLicenseLink', { brand: _ctx.brandConfig.client_name })), 1)
                  ]),
                  _: 1
                }),
                _createTextVNode(_toDisplayString(_ctx.t('teamPage.createTeamAgreeMid')), 1),
                _createVNode(_component_el_link, {
                  class: "privacy",
                  href: "/privacy/dubateamPrivacy.html",
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('teamPage.createTeamPrivacyLink', { brand: _ctx.brandConfig.client_name })), 1)
                  ]),
                  _: 1
                }),
                _createTextVNode(_toDisplayString(_ctx.t('teamPage.createTeamAgreeAfter')), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createVNode(_component_el_button, {
            disabled: !_ctx.allowSubmit,
            size: "medium",
            style: {"margin":"0 auto","display":"block"},
            type: "primary",
            onClick: _ctx.createTeam
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('teamPage.goConsole')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"]))
  ], 64))
}